// components/Layout.jsx
import React from 'react';
import { Outlet, useMatches, useParams } from 'react-router-dom';
import getOrganizationById from '../helpers/getOrganization';
import GoogleTagManager from '../components/google-tag-manager';
import BuyerAuthProvider from '../contexts/buyer-auth-context-provider';
import AuthGate from '../components/auth-gate/auth-gate';
import EnvironmentBadge from '../components/environment-badge/environment-badge';

// Which resource the active route is asking for, taken from the route's own
// `handle` in App.js so the policy lives beside the route definition. A route
// with no gate handle is not gated.
function useRouteGate() {
  const matches = useMatches();
  const match = [...matches].reverse().find((m) => m.handle?.gate);
  if (!match) return null;

  const { resourceType, param } = match.handle.gate;
  const resourceId = match.params?.[param];
  if (!resourceId) return null;

  return { resourceType, resourceId };
}

function Layout() {
  const { orgId } = useParams();
  const organization = getOrganizationById({ orgId });
  const gate = useRouteGate();

  // QA escape hatch: makes the gate reachable while the server is still in
  // observe mode, which is otherwise untestable end to end.
  const forceGate = new URLSearchParams(window.location.search).get('forceGate') === '1';

  return (
    <div>
      {/* Above the gate on purpose: a student being asked for a code should
          see whose brand is asking - and, off production, that this is not the
          live checkout. The testing badge sits under the logo on a phone, where
          the logo leaves no room beside it, and at the bar's right edge above. */}
      <header className="relative flex flex-col md:flex-row items-center bg-white md:bg-[#F7F8FA] justify-center gap-1 p-2">
        {organization && <img src={organization?.logo} className="max-w-xs h-[40px] w-[175px] object-contain" alt="logo" />}
        <EnvironmentBadge className="md:absolute md:right-4 md:top-1/2 md:-translate-y-1/2" />
      </header>
      <main>
        <BuyerAuthProvider gate={gate}>
          <AuthGate gated={Boolean(gate)} forceGate={forceGate}>
            <Outlet />
          </AuthGate>
        </BuyerAuthProvider>
        <GoogleTagManager orgId={orgId} />
      </main>
    </div>
  );
}
export default Layout;
